window.addEventListener('turbolinks:load', () => {
  if ($('body').hasClass('send_whatsapps')) {
    flatpickr(".datepicker", {
      enableTime: true,
      dateFormat: "d/m/Y H:i",
      minDate: "today",
      time_24hr: true,
      defaultDate: $("#send_whatsapp_default_start_at").val() != '' ? $("#send_whatsapp_default_start_at").val() : changeTimezone(new Date(), "America/Sao_paulo").getTime(),
      minuteIncrement: 1
    });

    if ($("#send_whatsapp_default_start_at").val() != '') {
      $("#send_whatsapp_start_at").val($("#send_whatsapp_default_start_at").val())
    }

    $('#send_whatsapp_messages').on('cocoon:before-insert', function (e, insertedItem, originalEvent) {
      select = $(insertedItem).find('select')[0]
      $(select).on('change', '', function (e) {
        checkSelect(this)
      });
    });

    $('#send_whatsapp_messages').on('cocoon:after-insert', function (e, insertedItem, originalEvent) {
      var requestedType = $('#send_whatsapp_messages').data('pending-message-type');
      if (requestedType) {
        $(insertedItem).find('.message_type').val(String(requestedType)).trigger('change');
        $('#send_whatsapp_messages').removeData('pending-message-type');
      }
      $('.send-whatsapp-flow-list').append(insertedItem);
      refreshSendWhatsappFlow();
      if ($('.row_send_whatsapp_message_fields').not('[style*="display: none"]').length >= 10) {
        $('.add_send_whatsapp_message_fields').hide()
      }
    });

    $('#send_whatsapp_messages').on('cocoon:after-remove', function (e, insertedItem, originalEvent) {
      refreshSendWhatsappFlow();
      if ($('.row_send_whatsapp_message_fields').not('[style*="display: none"]').length < 10) {
        $('.add_send_whatsapp_message_fields').show()
      }
    });

    $('.row_send_whatsapp_message_fields').on('change', '', function (e) {
      select = $(this).find('select')[0]
      checkSelect(select)
    });

    $('.row_send_whatsapp_message_fields').each(function (index, value) {
      select = $(value).find('select')[0]
      checkSelect(select)
    });

    if ($('.row_send_whatsapp_message_fields').not('[style*="display: none"]').length < 10) {
      $('.add_send_whatsapp_message_fields').show()
    }

    $(document).off('click.sendWhatsappFlow').on('click.sendWhatsappFlow', '.send-whatsapp-flow-add', function() {
      if (activeSendWhatsappBlocks().length >= 10) return;
      $('#send_whatsapp_messages').data('pending-message-type', $(this).data('message-type'));
      $('.add_send_whatsapp_message_fields .add_fields').first().trigger('click');
    });

    initSendWhatsappFlowDrag();
    refreshSendWhatsappFlow();

    $('.remove_send_whatsapp_number').on('click', '', function (e) {
      div = $(this).parent()
      if (window.confirm("Confirm?")) {
        $('.modal-photo').show()
        $.post("/remove_send_whatsapp_number?send_whatsapp_number_id=" + $(this).parent().attr('id'), function (data, status) {
          if (data.status) {
            div.remove();
          } else {
            alert('Error');
          }
          $('.modal-photo').hide()
        });
      }
    });

    $('.add_send_whatsapp_number').on('click', '', function (e) {
      $('.modal-photo').show()
      $.post("/add_send_whatsapp_number?send_whatsapp_id=" + $("#send_whatsapp_id").val() + "&send_whatsapp_number=" + $("#addNewNumber").val(), function (data, status) {
        if (data.status) {
          $("#addNewNumber").val('')
          $("#send_whatsapp_numbers").prepend("<div class='send_whatsapp_number_div' id=" + data.id + "><a href='javascript:void(0)' style='color: red' class='remove_send_whatsapp_number'><i class='fa fa-trash' aria-hidden='true' style='font-size: 25px;'></i></a><span> " + data.whatsapp_number + ', ' + data.name + ' </span></div>');
        } else {
          alert(data.message);
        }
        $('.modal-photo').hide()
      });
    });

    // Move modal to body to fix z-index issues
    $('#import_modal').appendTo("body");
  }
})

function activeSendWhatsappBlocks() {
  return $('.send-whatsapp-flow-list .send-whatsapp-flow-block').filter(function() { return $(this).css('display') !== 'none'; });
}

function refreshSendWhatsappFlow() {
  var blocks = activeSendWhatsappBlocks();
  blocks.each(function(index) {
    $(this).find('.send-whatsapp-message-position').val(index);
    var type = $(this).find('.message_type option:selected').text() || 'Mensagem';
    var delay = $(this).find('input[name*="[time_after]"]').val();
    $(this).find('.send-whatsapp-flow-title').text((index + 1) + '. ' + type);
    $(this).find('.send-whatsapp-flow-delay').text(delay ? formatSendWhatsappDelay(delay) : 'imediatamente');
  });
  $('.send-whatsapp-flow-canvas').toggleClass('is-empty', blocks.length === 0);
  $('.send-whatsapp-flow-add').prop('disabled', blocks.length >= 10);
}

function formatSendWhatsappDelay(value) {
  var totalSeconds = parseInt(value, 10);
  if (!Number.isFinite(totalSeconds) || totalSeconds <= 0) return 'imediatamente';

  var remaining = totalSeconds;
  var units = [
    { seconds: 86400, singular: 'dia', plural: 'dias' },
    { seconds: 3600, singular: 'hora', plural: 'horas' },
    { seconds: 60, singular: 'minuto', plural: 'minutos' }
  ];
  var readable = [];

  units.forEach(function(unit) {
    var amount = Math.floor(remaining / unit.seconds);
    if (amount > 0) {
      readable.push(amount + ' ' + (amount === 1 ? unit.singular : unit.plural));
      remaining %= unit.seconds;
    }
  });
  if (remaining > 0 && readable.length < 2) {
    readable.push(remaining + ' ' + (remaining === 1 ? 'segundo' : 'segundos'));
  }

  var rawUnit = totalSeconds === 1 ? 'segundo' : 'segundos';
  return 'após ' + totalSeconds + ' ' + rawUnit + (readable.length ? ' · ' + readable.slice(0, 2).join(' e ') : '');
}

function initSendWhatsappFlowDrag() {
  var dragged = null;
  $(document).off('.sendWhatsappFlowDrag')
    .on('mousedown.sendWhatsappFlowDrag touchstart.sendWhatsappFlowDrag', '.send-whatsapp-flow-block-heading', function() { $(this).closest('.send-whatsapp-flow-block').attr('draggable', 'true'); })
    .on('dragstart.sendWhatsappFlowDrag', '.send-whatsapp-flow-block', function(e) {
      dragged = this;
      $(this).addClass('is-dragging');
      e.originalEvent.dataTransfer.effectAllowed = 'move';
      e.originalEvent.dataTransfer.setData('text/plain', 'send-whatsapp-message');
    })
    .on('dragover.sendWhatsappFlowDrag', '.send-whatsapp-flow-list', function(e) {
      if (!dragged) return;
      e.preventDefault();
      e.originalEvent.dataTransfer.dropEffect = 'move';

      var pointerY = e.originalEvent.clientY;
      var nextBlock = activeSendWhatsappBlocks().not(dragged).filter(function() {
        var rect = this.getBoundingClientRect();
        return pointerY < rect.top + rect.height / 2;
      }).first();

      if (nextBlock.length) {
        if (dragged.nextElementSibling !== nextBlock[0]) nextBlock.before(dragged);
      } else if (this.lastElementChild !== dragged) {
        $(this).append(dragged);
      }
    })
    .on('drop.sendWhatsappFlowDrag', '.send-whatsapp-flow-list', function(e) {
      if (!dragged) return;
      e.preventDefault();
      refreshSendWhatsappFlow();
    })
    .on('dragend.sendWhatsappFlowDrag', '.send-whatsapp-flow-block', function() { $(this).removeClass('is-dragging').attr('draggable','false'); $('.drag-over').removeClass('drag-over'); dragged=null; refreshSendWhatsappFlow(); })
    .on('change.sendWhatsappFlowDrag input.sendWhatsappFlowDrag', '.message_type, input[name*="[time_after]"]', refreshSendWhatsappFlow);
}

function checkSelect(select) {
  var row = $(select).closest('.row_send_whatsapp_message_fields');
  var fileFieldDiv = row.find('input[type="file"]').closest('.field');

  if ($(select).val() == '2' || $(select).val() == '3' || $(select).val() == '15' || $(select).val() == '4' || $(select).val() == '5' || $(select).val() == '12') {
    fileFieldDiv.show();
    if ($(select).val() == '2' || $(select).val() == '12') {
      fileFieldDiv.find('input').attr("accept", '.png, .jpg, .jpeg');
    } else if ($(select).val() == '3' || $(select).val() == '15') {
      fileFieldDiv.find('input').attr("accept", '.mp4, video/mp4');
    } else if ($(select).val() == '4') {
      fileFieldDiv.find('input').attr("accept", 'audio/*');
    } else if ($(select).val() == '5') {
      fileFieldDiv.find('input').attr("accept", '.pdf');
    }
  } else {
    fileFieldDiv.hide();
  }
}

function changeTimezone(date, ianatz) {
  var invdate = new Date(date.toLocaleString('en-US', {
    timeZone: ianatz
  }));
  var diff = date.getTime() - invdate.getTime();
  return new Date(date.getTime() - diff);
}

window.validateFiles = function (inputFile) {
  var maxExceededMessage = "Tamanho máximo por arquivo (15 MB)";
  var maxFileSize = $(inputFile).data('max-file-size');
  var sizeExceeded = false;
  var extError = false;

  var acceptAttr = $(inputFile).attr('accept');
  var allowedExtension = ["jpg", "jpeg", "gif", "png", "mp3", "mp4", "pdf", "mov", "ogg", "csv", "md", "txt", "json", "xls", "xlsx", "doc", "docx"];

  if (acceptAttr && acceptAttr.includes('.')) {
    allowedExtension = acceptAttr.split(',').map(function (ext) {
      return ext.trim().replace('.', '').toLowerCase();
    });
  }

  var extErrorMessage = "Apenas arquivos " + allowedExtension.map(function(ext) { return "." + ext; }).join(", ") + " são permitidos.";

  $.each(inputFile.files, function () {
    if (this.size && maxFileSize && this.size > parseInt(maxFileSize)) { sizeExceeded = true; };
    var extName = this.name.split('.').pop().toLowerCase();
    if ($.inArray(extName, allowedExtension) == -1) { extError = true; };
  });

  if (sizeExceeded) {
    window.alert(maxExceededMessage);
    $(inputFile).val('');
  };

  if (extError) {
    window.alert(extErrorMessage);
    $(inputFile).val('');
  };
}

window.validateCsvFiles = function (inputFile) {
  var maxExceededMessage = "Tamanho máximo por aquivo (15 MB)";
  var extErrorMessage = "Apenas arquivos .csv são permitidos.";
  var allowedExtension = ["csv"];

  var extName;
  var maxFileSize = $(inputFile).data('max-file-size');
  var sizeExceeded = false;
  var extError = false;

  $.each(inputFile.files, function () {
    if (this.size && maxFileSize && this.size > parseInt(maxFileSize)) { sizeExceeded = true; };
    extName = this.name.split('.').pop();
    if ($.inArray(extName.toLowerCase(), allowedExtension) == -1) { extError = true; };
  });
  if (sizeExceeded) {
    window.alert(maxExceededMessage);
    $(inputFile).val('');
  };

  if (extError) {
    window.alert(extErrorMessage);
    $(inputFile).val('');
  };
}

window.validateAudioFiles = function (inputFile) {
  var maxExceededMessage = "Tamanho máximo por aquivo (15 MB)";
  var extErrorMessage = "Apenas arquivos .odd .wav .mp3 são permitidos.";
  var allowedExtension = ["ogg", "wav", "mp3"];

  var extName;
  var maxFileSize = $(inputFile).data('max-file-size');
  var sizeExceeded = false;
  var extError = false;

  $.each(inputFile.files, function () {
    if (this.size && maxFileSize && this.size > parseInt(maxFileSize)) { sizeExceeded = true; };
    extName = this.name.split('.').pop();
    if ($.inArray(extName.toLowerCase(), allowedExtension) == -1) { extError = true; };
  });
  if (sizeExceeded) {
    window.alert(maxExceededMessage);
    $(inputFile).val('');
  };

  if (extError) {
    window.alert(extErrorMessage);
    $(inputFile).val('');
  };
}

window.searchSendWhatsappNumber = function () {
  var input, filter, divs, i, txtValue, a;
  input = document.getElementById('searchInput');
  filter = input.value.toUpperCase();
  divs = document.getElementsByClassName('send_whatsapp_number_div');

  for (i = 0; i < divs.length; i++) {
    a = divs[i].getElementsByTagName("span")[0];
    txtValue = a.textContent || a.innerText;
    if (txtValue.toUpperCase().indexOf(filter) > -1) {
      divs[i].style.display = "";
    } else {
      divs[i].style.display = "none";
    }
  }
}

window.searchSendWhatsappDdiNumber = function () {
  var input, filter, divs, i, txtValue, a;
  input = document.getElementById('searchInputDdi');
  filter = input.value.toUpperCase();
  divs = document.getElementsByClassName('send_whatsapp_ddi_div');

  for (i = 0; i < divs.length; i++) {
    a = divs[i].getElementsByTagName("span")[0];
    txtValue = a.textContent || a.innerText;
    if (txtValue.toUpperCase().indexOf(filter) > -1) {
      divs[i].style.display = "";
    } else {
      divs[i].style.display = "none";
    }
  }
}
